export const ApiUrl="https://royasazan.com/api/";
//export const ApiUrl="http://localhost:8080/booking/";
export const WebURL="https://royasazan.com";
//export const WebURL="/";